import React from 'react';
import styled from 'styled-components';

const Container = styled.svg`
  display: flex;
  fill: currentColor;
`;

export const Frame: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <Container
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22zm0 2c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z"
        clipRule="evenodd"
      ></path>
      <rect width="3.84" height="15.36" x="22.08" y="10.56" rx="1.92"></rect>
      <rect width="3.84" height="3.84" x="39.36" y="22.08" rx="1.92"></rect>
      <rect width="3.84" height="15.36" x="22.08" y="10.56" rx="1.92"></rect>
      <rect width="3.84" height="3.84" x="22.08" y="39.36" rx="1.92"></rect>
      <rect width="3.84" height="3.84" x="4.8" y="22.08" rx="1.92"></rect>
      <rect width="3.84" height="3.84" x="22.08" y="4.8" rx="1.92"></rect>
    </Container>
  );
};
